<template>
  <div class="wrap">
    <div class="top  padding-l-r-260">
      <img src="../assets/icon-foot-qx.png">
      <a class="p-name font-size-16"
         target="_blank"
         href="http://www.wsbgt.com">网上报告厅</a>
      <a class="p-name font-size-16"
         target="_blank"
         href="http://www.bjadks.cn">职业全能培训库</a>
      <a class="p-name font-size-16"
         target="_blank"
         href="http://www.qiusuo.net.cn/">中国求索网</a>
      <a class="p-name font-size-16"
         target="_blank"
         href="http://www.wxuexi.cn">天天微学习</a>
      <a class="p-name font-size-16"
         target="_blank"
         href="http://www.lifelms.com">中国终身学习网</a>
    </div>
    <div class="bottom">
      <!-- <div class="margin ps">
        <a class="font-size-14">关于我们</a>
        <a class="font-size-14">商务合作</a>
        <a class="font-size-14">资质荣誉</a>
      </div> -->
      
      <div class="pb padding-l-r-260">
        <div class="pl">
          <div class='flex dtop'>
            <p class="font-size-14 font-color-8d">客服专线&nbsp;:&nbsp;400 - 8989 - 889 &nbsp;&nbsp;&nbsp;&nbsp;邮箱&nbsp;:&nbsp;market@bjadks.com</p>
            <p class="font-size-14 font-color-8d cursor-pointer" @click="toShensu"> &nbsp;&nbsp;&nbsp;&nbsp;版权申诉</p>
            <p class="font-size-14 font-color-8d cursor-pointer" @click="toFeedback"> &nbsp;&nbsp;&nbsp;&nbsp;意见反馈</p>
            <p class="font-size-14 font-color-8d">&nbsp;&nbsp;&nbsp;&nbsp;客户端&nbsp;:&nbsp;{{ip_str}}</p>
          </div>
          <p class="font-size-14 font-color-8d">北京爱迪科森教育科技股份有限公司&nbsp;(股票代码:430086) 地址&nbsp;:&nbsp;北京市海淀区上地信息路1号上地国际创业园A栋1层</p>
          <p class="font-size-14 font-color-8d">Copyright © 2004 - 2017 EDU&amp;SUN . All Rights Reserved. 爱迪科森 版权所有</p>
        </div>
        <div class="pr ">

          <img src="../assets/icon-foot-qr.png">
          <div>
            <p class="font-size-14 font-color-8d ">微信公众号</p>
            <p class="font-size-14 font-color-8d">爱迪科森</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kid-footer',
  data () {
    return {
      products: ['网上报告厅', '职业全能库', '中古求索网', '微学习中心', '中国终身学习网'],
      ip_str: ''
    }
  },
  mounted () {
    this.requestIP()
  },
  methods: {
    requestIP () {
      var that = this
      this.getRequest("api/v1/User/GetTrueIp").then(data => {
        if (data.IsSuccess) {
          that.ip_str = data.Data
        }
      });
    },
    toShensu() {
       window.open('https://www.wjx.top/vm/m70kFc3.aspx#', "_blank");
    },
    toFeedback() {
      window.open('https://www.wjx.cn/vm/eC9UOTk.aspx#', "_blank");
    }
  },
}
</script>

<style scoped>
.wrap {
  /* height: 3.42rem; */
  background-color: #343434;
}

.margin {
  margin: 0 2.6rem;
}

.top {
  background-color: #343434;
  height: 0.74rem;
  display: flex;
  align-items: center;
}

.top img {
  width: 1.33rem;
  height: 0.32rem;
  margin-right: 0.2rem;
}

.top .p-name {
  display: inline-block;
  padding: 0 0.1rem;
  color: #fff;
  text-decoration: none;
}

.top .p-name:hover {
  color: bisque;
}

.bottom {
  background-color: #3c3c3c;
  height: 1.6rem;
}

.bottom .ps {
  border-bottom: 1px solid#474747;
  display: flex;
  align-items: center;
  height: 0.83rem;
}

.bottom .ps a {
  color: #fff;
  display: inline;
  padding-right: 0.2rem;
  text-decoration: none;
  cursor: pointer;
}

.bottom .pb {
  display: flex;
  justify-content: space-between;

  height: 1.6rem;
}

.bottom .pb .pl {
  display: flex;
  flex-direction: column;
  margin-top: 0.46rem;
  /* justify-content: center; */
}

.bottom .pb .pl .dtop {
  background-color: rgba(0, 0, 0, 0);
}

.bottom .pb .pl p {
  margin-bottom: 0.06rem;
}

.bottom .pb .pl p:last-child {
  margin-bottom: 0;
}

.bottom .pb .pr {
  display: flex;
  margin-top: 0.46rem;
}

.bottom .pb .pr div {
  text-align: left;
  margin-left: 0.15rem;
}
.bottom .pb .pr p {
  margin-bottom: 0.06rem;
}
.bottom .pb .pr img {
  margin-top: -0.1rem;
  width: 0.96rem;
  height: 0.94rem;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue